import http from '@/http';

const CooperadoService = {
  async buscarLkpCooperado() {
    const cooperado = await http.get("/api/astec/getLkpCooperadoProjeto");

    return cooperado.data.map(item => ({
      name: item.DISPLAY,
      value: item.ID
    }));
  }
};

export default CooperadoService;
